import React, {Component} from 'react';
// import ReactEcharts from 'echarts-for-react';
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/legend';
import SimpleErrorBoundary from "../SimpleErrorBoundary";
import {Empty} from "antd";

class SummaryChart extends Component {
  static defaultProps = {
    data: [
      // {value:335, name:'Complete'},
      // {value:310, name:'Canceled'},
      // {value:1534, name: 'Pending'},
    ],
    title: null,
    subtext: null,
  };

  handleChartClick = (e) => {
    const { onClick } = this.props;
    if (onClick) {
      onClick(e);
    }
  };

  render() {
    const { data, title, subtext } = this.props;
    let events = {
      'click': this.handleChartClick,
    };
    let option = {
      title: {
        text: title,
        subtext: subtext,
        x: 'center',
      },
      tooltip: {
        trigger: 'item',
        formatter: "{a} <br/>{b}: {c} ({d}%)"
      },
      legend: {
        orient: 'horizontal',
        x: 'left',
        y: 'bottom',
        data: data && data.map(item => item.name)
      },
      series: [
        {
          name:'Status',
          type:'pie',
          radius:'65%',
          avoidLabelOverlap: true,
          label: {
            normal: {
              show: false,
              position: 'center'
            },
            emphasis: {
              show: false,
              textStyle: {
                fontSize: '30',
                fontWeight: 'bold'
              }
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          data: data
        }
      ]
    };
    if (!data) return <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300}}><Empty/></div>;
    return (
      <SimpleErrorBoundary>
        <ReactEchartsCore
          echarts={echarts}
          ref={(e) => {this.echarts_react = e; }}
          option={option}
          onEvents={events}
        />
      </SimpleErrorBoundary>
    );
  }
}

export default SummaryChart;



// WEBPACK FOOTER //
// ./src/components/Projects/SummaryChart.js